var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.025 6.712L7.498.974Q7.893.467 8.532.388q.638-.08 1.146.316l5.431 4.234q.507.396.587 1.034.079.638-.317 1.146l-4.473 5.738q-.396.507-1.034.586-.206.026-.398.002l-.435.56h6.147a.79.79 0 110 1.576H4.243a.811.811 0 01-.255-.022q-.493-.019-.89-.327L.856 13.482q-.51-.397-.587-1.039-.077-.64.323-1.148l2.284-2.894q-.13-.245-.167-.543-.079-.638.317-1.146zm6.685 5.116L4.314 7.62l4.413-5.66 5.396 4.206-4.413 5.66zM4.037 9.47l-2.195 2.782 2.219 1.73 3.036-.046 1.006-1.297-4.066-3.169zM3.033.779a.103.103 0 01.18.034l.385 1.346 1.147.861a.103.103 0 01-.034.18l-1.347.387-.86 1.144a.103.103 0 01-.18-.033l-.385-1.345-1.146-.861a.103.103 0 01.033-.18l1.344-.385L3.033.78zm11.683 9.28a.061.061 0 00-.11-.001l-.505.971-.963.458a.061.061 0 00-.002.11l.97.504.459.963a.061.061 0 00.11.002l.503-.968.965-.46a.061.061 0 00.002-.11l-.97-.503-.46-.965z",
    fillRule: "evenodd",
    fill: "#414751"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicEraser);
export default __webpack_public_path__ + "static/media/magic-eraser.07a9994237bfc83d783edbdc69270cc2.svg";
export { ForwardRef as ReactComponent };